import {LogoTextSize} from "../../controllers/SystemUmmiaLogoTextController";
import {isNullOrUndefined} from "../../services/Validator";
import {kSystemImages} from "../../constants/images";
import SystemAppSideBarTooltip from "../tooltips/SystemAppSideBarTooltip";
import {useRef, useState} from "react";

export default function SystemAppSideBarUmmiaLogoImage({logoTextSize, onLogoPressed, extraClass}) {
    // Used through different header components to show app
    // logo text with a given size

    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        setShowTooltip(false);
        setTooltipPos({
            x: e.clientX,
            y: e.clientY,
        });
        clearTimeout(idleTimer.current);
        idleTimer.current = setTimeout(() => {
            setShowTooltip(true);
        }, 300); // délai "souris immobile"
    };
    const handleMouseLeave = () => {
        clearTimeout(idleTimer.current);
        setShowTooltip(false);
    };
    const idleTimer = useRef(null);

    // BUILD
    return(
        <div className={'relative'}
             onMouseMove={handleMouseMove}
             onMouseLeave={handleMouseLeave}>
            <div className={`${extraClass} + " " + ${renderLogoSize(logoTextSize)} + ${isNullOrUndefined(onLogoPressed) ? "" : " cursor-pointer"}`}
                 onClick={onLogoPressed}>
                <img className={"h-full object-contain"}
                     src={kSystemImages.neoUmmiaLogo}
                     alt="Logo" />
            </div>
            {showTooltip && (
                <SystemAppSideBarTooltip showTooltip={showTooltip}
                                         tooltip={"Accueil"}
                                         tooltipPos={tooltipPos} />
            )}
        </div>
    );

    // METHODS
    // ---- UI : Render logo size
    function renderLogoSize(logoTextSize) {
        switch(logoTextSize) {
            case LogoTextSize.XSMALL:
                return "h-[24px] min-h-[24px] max-h-[24px] w-[24px] min-w-[24px] max-w-[24px] mb-4"
            case LogoTextSize.SMALL:
                return "h-[32px] min-h-[32px] max-h-[32px] w-[32px] min-w-[32px] max-w-[32px] mb-6"
            case LogoTextSize.MEDIUM:
                return "h-[40px] min-h-[40px] max-h-[40px] w-[40px] min-w-[40px] max-w-[40px] mb-6"
            case LogoTextSize.LARGE:
                return "h-[48px] min-h-[48px] max-h-[48px] w-[48px] min-w-[48px] max-w-[48px] mb-6"
            default:
                return "h-[32px] min-h-[32px] max-h-[32px] w-[32px] min-w-[32px] max-w-[32px] mb-6"
        }
    }
}